export enum AppRolesEnum {	
	// pages
	orders_Read = 'Orders.Read',
	customers_Read = 'Customers.Read',
	userData_Read = 'UserData.Read',
	userData_Modify = 'UserData.Modify',
	import_Modify = 'Import.Modify',
	
	// reports
	redatedOrdersReport_Read = 'RedatedOrdersReport.Read',
	reducedOrdersReport_Read = 'ReducedOrdersReport.Read',
	reducedMaterialsReport_Read = 'ReducedMaterialsReport.Read',
	undeliveredOrdersReport_Read = 'UndeliveredOrdersReport.Read',
	mchdReport_Read = 'MchdReport.Read',
	countryDeliveriesSummaryReport_Read = 'CountryDeliveriesSummaryReport.Read',
	countryDeliveriesTradesDepoReport_Read = 'CountryDeliveriesTradesDepoReport.Read',
	countryDeliveriesTradesDistrictReport_Read = 'CountryDeliveriesTradesDistrictReport.Read',
	countryDeliveriesCustomerReport_Read = 'CountryDeliveriesCustomerReport.Read',
	countryDeliveriesSkuReport_Read = 'CountryDeliveriesSkuReport.Read',
	countryDeliveriesSkuReportDcDetail_Read = 'CountryDeliveriesSkuReportDcDetail.Read',
	countryDeliveriesSkuReportDistrictDetail_Read = 'CountryDeliveriesSkuReportDistrictDetail.Read',
	topRescheduledSKUs_Read = 'TopRescheduledSKUs.Read',
	orderReports_Modify = 'OrderReports.Modify',
	materialReports_Modify = 'MaterialReports.Modify',
}